import { render } from "./Pages-Content.vue?vue&type=template&id=3dac1bb1&scoped=true"
import script from "./Pages-Content.vue?vue&type=script&lang=js"
export * from "./Pages-Content.vue?vue&type=script&lang=js"

import "./Pages-Content.vue?vue&type=style&index=0&id=3dac1bb1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dac1bb1"]])

export default __exports__